$(document).ready(function () {
    $('.product-tabs .tabs-nav-home li:first-child').addClass('active'),
      $('.product-tabs .tab-content').hide(),
      $('.product-tabs .tab-content:first').show(),
      $('.product-tabs .tabs-nav-home li').click(function () {
        $('.product-tabs .tabs-nav-home li').removeClass('active'),
          $(this).addClass('active'),
          $('.product-tabs .tab-content').hide();
        var e = $(this).find('a').attr('href');
        return $(e).fadeIn(), !1;
      })
  });